
import { BlogPost } from "@/types/blog";
import { content } from "./content";

export const KiFianzielleEmotionaleUnabhaengigkeit: BlogPost = {
  title: "Künstliche Intelligenz: Chancen, Risiken und dein Weg zur finanziellen und emotionalen Unabhängigkeit",
  metaTitle: "KI & finanzielle Unabhängigkeit: Chancen nutzen",
  excerpt: "Wie du KI als Werkzeug für bessere Finanzentscheidungen und emotionale Balance nutzt. Chancen erkennen, Risiken einordnen.",
  date: "18.03.2025",
  slug: "ki-finanzielle-emotionale-unabhaengigkeit",
  author: 'Jörg Hörmann',
  authorTitle: 'Finanz- & Executive Coach',
  imageUrl: "/images/blog/ki-finanzielle-unabhaengigkeit.jpg",
  category: "Technologie & Systeme",
  tags: ["KI", "Finanzielle Unabhängigkeit", "Emotionale Balance", "Technologie", "Coaching"],
  content
};
